import { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import { tonnageListAsync } from "../../../../redux/features/tonnage-master/tonnageSlice";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { changeTonnageStatus } from "../../../../Api/dispatch/tonnage-dispatch";
import { removeTonnageMasterAsync } from "../../../../redux/features/tonnage-master/removeTonnageMasterSlice";

export default function TonnageList() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const tonnageMasterList = useSelector((state) => state.tonnageMasterSlice.data);

   const [records, setRecords] = useState([]);

   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });
   const handleDelete = (id) => {
      const confirmDelete = window.confirm(
         "Are you sure you want to delete this record?"
      );

      if (!confirmDelete) return;

      dispatch(backdropLoadingAction(true));

      dispatch(
         removeTonnageMasterAsync({
            id,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Tonnage deleted successfully");

               // Refresh list after delete
               dispatch(tonnageListAsync({}));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         })
      );
   };

   // Handle active inactive
   const handleActiveInactive = (tonnage) => {
      setIsActiveLoading({ id: tonnage?.id, status: true });
      changeTonnageStatus({
         id: tonnage?.id,
         status: tonnage?.is_active === "1" ? "0" : "1",
      })
         .then((res) => {
            setIsActiveLoading({ id: tonnage?.id, status: false });
            dispatch(tonnageListAsync({}));
            toast.success(
               `tonnage ${tonnage?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: tonnage?.id, status: false });
            //toast.error(
            //    `Failed to ${
            //       tonnage?.is_active === "1" ? "deactivate" : "activate"
            //    } location`
            // );
         });
   };

   const columns = [
      {
         name: "Tonnage",
         selector: (row) => row.tonnage,
         sortable: true,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/fleet-master/tonnage/edit/${row.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>

                   <button className="btn" onClick={() => handleDelete(row.id)}>
                     <BsTrashFill
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>


                  {/* <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  /> */}

                 
               </div>
            );
         },
      },
   ];

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         tonnageListAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         })
      );
   }, []);

   useEffect(() => {
      if (tonnageMasterList) setRecords(tonnageMasterList);
   }, [tonnageMasterList]);

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = tonnageMasterList?.filter((item) => {
         return item?.tonnage?.toLowerCase().includes(searchText);
      });
      setRecords(newData);
   };

   return (
      <div>
         <BodyHeader title="Tonnage Master List" />

         <div className="px-3">
            <div className="d-flex justify-content-start">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
